<!-- <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="traducciones.length == 0">
    <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
    <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.TITULOALTERNO' | translate}}</div>
</div> -->
<mat-horizontal-stepper *ngIf="idiomas && fgListo" (selectionChange)="cambioIdioma($event)">

    <mat-step *ngFor="let idioma of idiomas; index as i;" label="{{'NOMBREIDIOMAS.'+idioma.clave|translate}}" state="idiomaIco" errorMessage="{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.NOTYET' | translate}}">

      <ng-container *ngIf="cargando; else cargaCompleta">
        <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
          <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
          <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
        </div>
      </ng-container>

      <ng-template #cargaCompleta>
        <form [formGroup]="formGroups[i]" fxLayout="column" fxLayoutAlign="space-between stretch">
<ng-container *ngFor="let idiomaPreg of textosPreguntasFiltrados" >

          <ng-container *ngIf="idiomaPreg.clave==idioma.clave">
          <!-- <ng-container *ngIf="!sinReactivos; else sinReactivosMsg"> -->
            <table *ngFor="let pregunta of idiomaPreg.preguntas; index as j;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">

              <tr fxLayout="row">
                <th fxFlex="50" class="accent-500 p-20">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.MAIN' | translate}}</th>
                <th fxFlex="50" class="accent-100 p-20">{{'NOMBREIDIOMAS.'+idioma.clave|translate}}</th>
              </tr>
              <tr fxLayout="row" fxLayoutAlign="space-between stretch">

                <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch" class="p-20">

                  <h3><code>{{ pregunta.textoPregunta }}</code></h3>
                </td>

                <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">

                  <mat-form-field appearance="outline" >
                    <mat-label>{{'CERTIFICAR.FORALL.PRACTICE_TRANSLATE_REACTIVOS' | translate}}</mat-label>
                    <textarea  matInput required *ngIf="pregunta.traduccion ==''"  name="traduccion{{j}}" formControlName="traduccion{{j}}"  (blur)="guardaTraduccion($event,pregunta._id,idioma._id,pregunta.orden,pregunta)"></textarea>
                    <textarea  matInput required *ngIf="pregunta.traduccion !=''" [(ngModel)]="pregunta.traduccion" name="traduccion{{j}}" formControlName="traduccion{{j}}"  (blur)="guardaTraduccion($event,pregunta._id,idioma._id,pregunta.orden,pregunta)"></textarea>
                    <mat-error>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.ERROR' | translate}}</mat-error>
                  </mat-form-field>

                </td>
              </tr>


              <tr fxLayout="row" fxLayoutAlign="end none">
                <th colspan="2">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.COMPLETE' | translate}}
                  <mat-icon>check_circle_outline</mat-icon>
                </th>
              </tr>

            </table>
          <!-- </ng-container> -->


          <!-- <ng-template #sinReactivosMsg>
            <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'FOCUS.REACTIVOS.SIN' | translate}}</h2>
                <mat-icon class="ml-20 s-40">error_outline</mat-icon>
              </div>
            </div>
          </ng-template> -->
       </ng-container>
       </ng-container>
        </form>
      </ng-template>

    </mat-step>


    <!-- Icon overrides. -->
    <ng-template matStepperIcon="idiomaIco">
        <mat-icon>language</mat-icon>
    </ng-template>
</mat-horizontal-stepper>
